import { useEffect, useRef, useState } from "react";
import AddIcon from '@mui/icons-material/Add';
import ProgressBarODM from "./ProgressBar";
import { assetti, esecuzioni, Esercizio, finalita, modalita } from "../interfaces/Esercizio";
import CompartiMuscolari from "./CompartiMuscolari";
import ImageUploadPreview from "./ImageUploadPreview";
import ModalPosizioneFinalita from "./ModalPosizioneFinalità";
import ComplexFunctionModal from "./ComplexFunctionModal";
import ModeIcon from '@mui/icons-material/Mode';
import IssueHandlingModal from "./IssueHandlingModal";
import ReminderModal from "./ReminderModal";
import ParametriValutativi from "./ParametriValutativi";
import { Checkbox, FormControl, InputLabel, ListItemText, MenuItem, OutlinedInput, Select, TextField } from "@mui/material";
import EsercizioCorrelato from "./EsercizioCorrelato"

import strechingHuman from "../assets/icons/strechingHuman.svg"
import elasticBand from "../assets/icons/elasticBand.svg"
import elasticRope from "../assets/icons/elasticRope.svg"
import doubleHandleMedicineBall from "../assets/icons/doubleHandleMedicineBall.svg"
import barbell from "../assets/icons/barbell.svg"
import dumpbell from "../assets/icons/dumpbell.svg"
import bench from "../assets/icons/bench.svg"
import foamRoller from "../assets/icons/foamRoller.svg"
import disk from "../assets/icons/disk.svg"
import broomStick from "../assets/icons/broomStick.svg"


interface EsercizioDetailsProps {
    //token: string;
    esercizio: Esercizio;
    handleChange: <K extends keyof Esercizio>(key: K, value: Esercizio[K]) => void;
}

interface ReminderOption {
    id: number | null;
    name: string;
    description: string;
}

interface select {
    id: number | null;
    name: string;
    icon?: string;
    description?: string
}

const iconMap: any = {
    elasticBand,
    elasticRope,
    doubleHandleMedicineBall,
    barbell,
    dumpbell,
    bench,
    foamRoller,
    disk,
    broomStick
};


export default function EsercizioDetails({ handleChange, esercizio }: EsercizioDetailsProps) {
    const fileInputRef = useRef<HTMLInputElement | null>(null);

    const [modalEF, setModalEF] = useState<boolean>(false);
    const [modalComplexFunction, setMoldalComplexFunction] = useState<boolean>(false);
    const [modalIssues, setModalIssues] = useState<boolean>(false);
    const [modalReminder, setModalReminder] = useState<boolean>(false);

    const [reminderOptions, setReminderOptions] = useState<ReminderOption[]>([]);
    const isFirstReminderRender = useRef(true);
    const [complex_functionOptions, setComplex_functionOptions] = useState<select[]>([]);
    const [equipmentOptions, setEquipmentOptions] = useState<select[]>([]);
    const [issue_forOptions, setIssue_forOptions] = useState<select[]>([]);
    const isFirstIssuesRender = useRef(true);
    
    const toggleReminder = (id: number) => {
        console.log("toggleReminder: " + esercizio.reminders)
        const isAlreadySelected = esercizio.reminders.includes(id);
        if (!isAlreadySelected && esercizio.reminders.length > 5) return;

        const updatedReminders = isAlreadySelected
            ? esercizio.reminders.filter(reminderId => reminderId !== id)
            : [...esercizio.reminders, id];

        handleChange("reminders", updatedReminders);
    };

    const handleEvaluationalParamsChange = (group: string, newParams: { key: string; value: number }[]) => {
        const key = ("evaluation_params_" + group) as keyof Esercizio;
        handleChange(key, newParams);
    };

    const fetchReminders = async () => {
        try {
            const headers = new Headers();
            //if (token) {
            //    headers.set('Authorization', `Token ${token}`);
            //}
            headers.set('Accept', 'application/json');
            const requestInit: RequestInit = {
                method: 'GET',
                headers: headers,
                credentials: 'include',
            }
            const response = await fetch('/api/v0/reminders', requestInit);
            if (!response.ok) throw new Error('Errore nel recupero delle attività');
            const data: ReminderOption[] = await response.json();
            setReminderOptions(data);
        } catch (err: any) {
            console.log(err.message);
        }
    };

    const toggleEquipment = (id: number) => {
        const equipment = esercizio.equipment ? esercizio.equipment : [];
        if (!equipment.includes(id) && equipment.length >= 2) return;

        const updatedEquipment = equipment.includes(id)
            ? equipment.filter(equipmentId => equipmentId !== id)
            : [...equipment, id];

        handleChange("equipment", updatedEquipment);
    };

    const handleSelectChangeEquipment = (event: any) => {
        const {
            target: { value },
        } = event;

        const previous = esercizio.equipment ?? [];
        const newValue = typeof value === "string" ? value.split(",") : value;

        const added = newValue.find((id: any) => !previous.includes(id));
        const removed = previous.find((id) => !newValue.includes(id));

        if (added !== undefined) {
            toggleEquipment(added);
        } else if (removed !== undefined) {
            toggleEquipment(removed);
        }
    };


    const fetchIssues = async () => {
        try {
            const headers = new Headers();
            //if (token) {
            //    headers.set('Authorization', `Token ${token}`);
            //}
            headers.set('Accept', 'application/json');
            const requestInit: RequestInit = {
                method: 'GET',
                headers: headers,
                credentials: 'include',
            }
            const response = await fetch('/api/v0/issues', requestInit);
            if (!response.ok) throw new Error('Errore nel recupero delle attività');
            const data: ReminderOption[] = await response.json();
            setIssue_forOptions(data);
        } catch (err: any) {
            console.log(err.message);
        }
    };

    const fetchEquipment = async () => {
        try {
            const headers = new Headers();
            //if (token) {
            //    headers.set('Authorization', `Token ${token}`);
            //}
            headers.set('Accept', 'application/json');
            const requestInit: RequestInit = {
                method: 'GET',
                headers: headers,
                credentials: 'include',
            }
            const response = await fetch('/api/v0/equipments', requestInit);
            if (!response.ok) throw new Error('Errore nel recupero delle attività');
            const data: ReminderOption[] = await response.json();
            setEquipmentOptions(data);
        } catch (err: any) {
            console.log(err.message);
        }
    };

    const fetchComplex_function = async () => {
        try {
            const headers = new Headers();
            headers.set('Accept', 'application/json');

            const requestInit: RequestInit = {
                method: 'GET',
                headers: headers,
                credentials: 'include',
            };

            const response = await fetch('/api/v0/complex-functions', requestInit);
            if (!response.ok) throw new Error('Errore nel recupero delle attività');

            const data: select[] = await response.json();
            setComplex_functionOptions(data);

            if (
                esercizio.complex_function !== null &&
                !data.some(option => option.id === esercizio.complex_function)
            ) {
                handleChange("complex_function", null);
            }
        } catch (err: any) {
            console.log(err.message);
        }
    };


    useEffect(() => {
        if (isFirstIssuesRender.current) {
          isFirstIssuesRender.current = false;
          return;
        }

        const updatedRecommendedFor = esercizio.recommended_for.filter(id =>
            issue_forOptions.some(option => option.id === id)
        );
        if (updatedRecommendedFor.length !== esercizio.recommended_for.length) {
            handleChange("recommended_for", updatedRecommendedFor);
        }
        const updatedContraindicatedFor = esercizio.contraindicated_for.filter(id =>
            issue_forOptions.some(option => option.id === id)
        );
        if (updatedContraindicatedFor.length !== esercizio.contraindicated_for.length) {
            handleChange("contraindicated_for", updatedContraindicatedFor);
        }
    }, [issue_forOptions]);

    useEffect(() => {
        if (
            esercizio.complex_function !== null &&
            !complex_functionOptions.some(option => option.id === esercizio.complex_function)
        ) {
            handleChange("complex_function", null);
        }
    }, [complex_functionOptions]);

    useEffect(() => {
        if (isFirstReminderRender.current) {
          isFirstReminderRender.current = false;
          return;
        }

        const updatedReminders = esercizio.reminders.filter(id =>
            reminderOptions.some(option => option.id === id)
        );
        if (updatedReminders.length !== esercizio.reminders.length) {
            handleChange("reminders", updatedReminders);
        }
    }, [reminderOptions]);

    useEffect(() => {
        fetchIssues()
        fetchComplex_function()
        fetchReminders()
        fetchEquipment();
    }, []);

    return (
        <div className="p-4 bg-white shadow-md rounded-lg max-w-lg mx-auto">

            <div className="row justify-content-between">
                <div className="col-6">
                    <h5 className="font-semibold mb-3">Immagine di anteprima</h5>
                </div>
                <div className="col-6 text-end">
                    <ImageUploadPreview
                        image={esercizio.preview_image}
                        onChange={(newImage) => handleChange("preview_image", newImage)}
                    />
                </div>
            </div>

            <h5 className="font-semibold mb-3">Info generali</h5>
            <TextField
                label="Nome corto*"
                variant="outlined"
                fullWidth
                value={esercizio.full_name}
                onChange={(e) => handleChange("full_name", e.target.value)}
                inputProps={{ maxLength: 35 }}
                helperText={`${esercizio.full_name.length}/35`}
                FormHelperTextProps={{ style: { textAlign: 'right' } }}
                className="mb-3"
            />
            <TextField
                label="Nome vocale"
                variant="outlined"
                fullWidth
                value={esercizio.vocal_name}
                onChange={(e) => handleChange("vocal_name", e.target.value)}
                inputProps={{ maxLength: 4000 }}
                FormHelperTextProps={{ style: { textAlign: 'right' } }}
                className="mb-3"
            />
            <TextField
                label="Descrizione*"
                variant="outlined"
                fullWidth
                multiline
                rows={3}
                value={esercizio.full_description}
                onChange={(e) => handleChange("full_description", e.target.value)}
                inputProps={{ maxLength: 250 }}
                helperText={`${esercizio.full_description.length}/250`}
                FormHelperTextProps={{ style: { textAlign: 'right' } }}
                className="mb-3"
            />
            <TextField
                label="Descrizione vocale"
                variant="outlined"
                fullWidth
                multiline
                rows={3}
                value={esercizio.vocal_description}
                onChange={(e) => handleChange("vocal_description", e.target.value)}
                inputProps={{ maxLength: 4000 }}
                FormHelperTextProps={{ style: { textAlign: 'right' } }}
                className="mb-3"
            />
            <div className="row">
                <div className="col-5 d-flex mb-3">
                    <button className="btn btn-dark me-2" onClick={() => setModalEF(!modalEF)}>
                        <AddIcon />
                    </button>
                    <input
                        disabled
                        className="form-control me-3"
                        placeholder="Posizione*"
                        value={esercizio.position}
                    //onChange={(e) => handleChange("position", e.target.value)}
                    />
                    <ModalPosizioneFinalita
                        open={modalEF}
                        onClose={() => setModalEF(false)}
                        esercizio={esercizio}
                        positionChange={(e) => handleChange("position", e.value)}
                        purposeChange={(e) => handleChange("purpose", e.value)}
                    />
                </div>
            </div>
            <div className="d-flex">
                <h5 className="font-semibold mb-3">Finalità*</h5>
                <p>{`\(Questo parametro viene settato mediante il codice "Posizione"\)`}</p>
            </div>

            <div className="mb-3">
                {finalita.map(option => (
                    <div key={option.value} className="flex items-center gap-2">
                        <input
                            type="radio"
                            name="purpose"
                            value={option.value}
                            checked={esercizio.purpose === option.value}
                            //onChange={(e) => handleChange("purpose", e.target.value)}
                            onChange={(e) => { }}
                        /> {option.name}
                    </div>
                ))}
            </div>
            <EsercizioCorrelato
                current_id={esercizio.id!}
                esercizioCorrelato={esercizio.esercizio_correlato ? esercizio.esercizio_correlato : 0}
                onChange={(value) => {
                    handleChange("esercizio_correlato", value)
                }}
            />

            <h5 className="font-semibold mb-3">Esecuzione*</h5>
            <div className="mb-3">
                {esecuzioni.map(option => (
                    <div key={option.value} className="flex items-center gap-2">
                        <input
                            type="radio"
                            name="execution"
                            value={option.value}
                            checked={esercizio.execution === option.value}
                            onChange={(e) => handleChange("execution", e.target.value)}
                        /> {option.name}
                    </div>
                ))}
            </div>

            <h5 className="font-semibold mb-3">Modalità*</h5>
            <div className="mb-3">
                {modalita.map(option => (
                    <div key={option.value} className="flex items-center gap-2">
                        <input
                            type="radio"
                            name="mode"
                            value={option.value}
                            checked={esercizio.mode === option.value}
                            onChange={(e) => handleChange("mode", e.target.value)}
                        /> {option.name}
                    </div>
                ))}
            </div>

            <div className="mb-3">
                <CompartiMuscolari
                    title="Comparto*"
                    field="muscle_groups"
                    value={esercizio.muscle_groups}
                    onChange={handleChange}
                    edit={true}
                />
            </div>

            <div className="mb-4">
                <h5 className="font-semibold mb-1">Assetto*</h5>
                <select
                    className="form-control"
                    value={esercizio.posture}
                    onChange={(e) => handleChange("posture", e.target.value)}
                >
                    {assetti.map((option) => (
                        <option key={option.value} value={option.value}>
                            {option.name}
                        </option>
                    ))}
                </select>
            </div>

            <div className="mb-4">
                <div className="row">
                    <div className="col text-start">
                        <h5 className="font-semibold mb-1">Funzione complessa</h5>
                    </div>
                    <div className="col text-end">
                        <button className="btn btn-light" onClick={() => setMoldalComplexFunction(!modalComplexFunction)}>
                            gestisci <ModeIcon />
                        </button>
                        <ComplexFunctionModal
                            open={modalComplexFunction}
                            onClose={() => setMoldalComplexFunction(false)}
                            list={complex_functionOptions}
                            setList={() => setComplex_functionOptions}
                        />
                    </div>
                </div>

                <select
                    className="form-control mt-2"
                    value={esercizio.complex_function ?? ''}
                    onChange={(e) => handleChange("complex_function", Number(e.target.value)==0 ? null : Number(e.target.value))}
                >
                    <option value="">Nessuna</option>
                    {complex_functionOptions.map((option) => (
                        option.id &&
                        <option key={option.id} value={option.id}>
                            {option.name}
                        </option>
                    ))}
                </select>
            </div>


            <div className="row">
                <div className="col text-start">
                    <h5 className="font-semibold mb-1">Attrezzo*</h5>
                </div>
            </div>
            <FormControl fullWidth size="small" className="mb-4">
                <InputLabel id="mode-label"></InputLabel>
                <Select
                    labelId="mode-label"
                    value={esercizio.equipment && esercizio.equipment[0] ? esercizio.equipment[0] : 0}
                    label=""
                    onChange={(e) => {
                        const selected = Number(e.target.value);
                        handleChange("equipment", selected === 0 ? [] : [selected]);
                    }}
                >
                    <MenuItem key={0} value={0}>
                        <img src={strechingHuman} alt="icon" width={30} className="me-3" />
                        Solo peso corporeo
                    </MenuItem>
                    {equipmentOptions.map((e) => (
                        e.id && e.id !== 0 ? (
                            <MenuItem key={e.id} value={e.id}>
                                <img src={iconMap[e.icon ? e.icon : ""]} alt="icon" width={30} className="me-3" />
                                {e.name}
                            </MenuItem>
                        ) : null
                    ))}
                </Select>
            </FormControl>

            {esercizio.equipment && esercizio.equipment.length > 0 && (
                <FormControl fullWidth size="small" className="mb-4">
                    <InputLabel id="second-equipment-label">Secondo attrezzo</InputLabel>
                    <Select
                        labelId="second-equipment-label"
                        value={esercizio.equipment[1] || ""}
                        label="Secondo attrezzo"
                        onChange={(e) => {
                            const second = Number(e.target.value);
                            if (second === -1) {
                                handleChange("equipment", [esercizio.equipment[0]]);
                            } else {
                                handleChange("equipment", [esercizio.equipment[0], second]);
                            }
                        }}
                    >
                        <MenuItem key={-1} value={-1}>
                            Nessuno
                        </MenuItem>
                        {equipmentOptions.map((e) =>
                            e.id && e.id !== 0 && e.id !== esercizio.equipment[0] ? (
                                <MenuItem key={e.id} value={e.id}>
                                    <img src={iconMap[e.icon ? e.icon : ""]} alt="icon" width={30} className="me-3" />
                                    {e.name}
                                </MenuItem>
                            ) : null
                        )}
                    </Select>
                </FormControl>
            )}

            <div className="mb-4">
                <div className="row">
                    <div className="col text-start">
                        <h5 className="font-semibold mb-1">Raccomandato per</h5>
                    </div>
                    <div className="col text-end">
                        <button className="btn btn-light" onClick={() => setModalIssues(!modalIssues)}>
                            gestisci <ModeIcon />
                        </button>
                    </div>
                </div>

                <FormControl fullWidth margin="normal">
                    <InputLabel id="recommended-for-label">Scegli una problematica</InputLabel>
                    <Select
                        labelId="recommended-for-label"
                        multiple
                        value={esercizio.recommended_for ?? []}
                        onChange={(e) => {
                            const selectedValues = e.target.value as number[];
                            handleChange("recommended_for", selectedValues);
                        }}
                        input={<OutlinedInput label="Scegli una problematica" />}
                        renderValue={(selected) =>
                            issue_forOptions
                                .filter((option) => selected.includes(option.id ? option.id : -1))
                                .map((option) => option.name)
                                .join(", ")
                        }
                    >
                        {issue_forOptions.map((option) => (
                            option.id &&
                            <MenuItem key={option.id} value={option.id}>
                                <Checkbox
                                    checked={esercizio.recommended_for?.includes(option.id) ?? false}
                                />
                                <ListItemText primary={option.name} />
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </div>
            <div className="mb-4">
                <div className="row">
                    <div className="col text-start">
                        <h5 className="font-semibold mb-1">Controindicato per</h5>
                    </div>
                    <div className="col text-end">
                        <button className="btn btn-light" onClick={() => setModalIssues(!modalIssues)}>
                            gestisci <ModeIcon />
                        </button>
                        <IssueHandlingModal
                            open={modalIssues}
                            onClose={() => setModalIssues(false)}
                            list={issue_forOptions}
                            setList={setIssue_forOptions}
                        />
                    </div>
                </div>

                <FormControl fullWidth margin="normal">
                    <InputLabel id="contraindicated-for-label">Scegli una problematica</InputLabel>
                    <Select
                        labelId="contraindicated-for-label"
                        multiple
                        value={esercizio.contraindicated_for ?? []}
                        onChange={(e) => {
                            const selectedValues = e.target.value as number[];
                            handleChange("contraindicated_for", selectedValues);
                        }}
                        input={<OutlinedInput label="Scegli una problematica" />}
                        renderValue={(selected) =>
                            issue_forOptions
                                .filter((option) => selected.includes(option.id ? option.id : -1))
                                .map((option) => option.name)
                                .join(", ")
                        }
                    >
                        {issue_forOptions.map((option) => (
                            option.id &&
                            <MenuItem key={option.id} value={option.id}>
                                <Checkbox
                                    checked={esercizio.contraindicated_for?.includes(option.id) ?? false}
                                />
                                <ListItemText primary={option.name} />
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </div>

            <div className="mb-3">
                <ProgressBarODM
                    title="Complessità gestione gravitaria*"
                    levels={5}
                    field="gravity_management_complexity"
                    value={esercizio.gravity_management_complexity}
                    onChange={handleChange}
                />
                <ProgressBarODM
                    title="Complessità coordinazione motoria*"
                    levels={5}
                    field="motor_coordination_complexity"
                    value={esercizio.motor_coordination_complexity}
                    onChange={handleChange}
                />
                <ProgressBarODM
                    title="Intensità cardio-respiratoria*"
                    levels={5}
                    field="cardiorespiratory_complexity"
                    value={esercizio.cardiorespiratory_complexity}
                    onChange={handleChange}
                />
            </div>

            <div className="mb-4">
                <ParametriValutativi
                    value_cgg={esercizio.evaluation_params_cgg}
                    value_ccm={esercizio.evaluation_params_ccm}
                    value_icr={esercizio.evaluation_params_icr}
                    onChange={handleEvaluationalParamsChange}
                />
            </div>

            <div className="row">
                <div className="col text-start">
                    <h5 className="font-semibold mb-1">Reminder durante l'esecuzione (Max 6)</h5>
                </div>
                <div className="col text-end">
                    <button className="btn btn-light" onClick={() => setModalReminder(!modalReminder)}>
                        gestisci <ModeIcon />
                    </button>
                    <ReminderModal
                        open={modalReminder}
                        onClose={() => setModalReminder(false)}
                        list={reminderOptions}
                        setList={setReminderOptions}
                    />
                </div>
            </div>

            <div className="flex flex-wrap gap-2">
                {reminderOptions.map(option => (
                    <button
                        key={option.id}
                        className={`m-1 rounded-5 btn ${esercizio.reminders.includes(option.id ? option.id : -1) ? "btn-dark" : "btn-light"}`}
                        onClick={() => toggleReminder(option.id ? option.id : -1)}
                    >
                        {option.name}
                    </button>
                ))}
            </div>

        </div>

    );
}